import React, { useEffect, useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import StapMainLayout from './step-main'
import { BsChevronDoubleLeft } from 'react-icons/bs'
import { EMP_CHECK_LIST_DETAIL_ST_4 } from '../../../../router/routes'
import StapPage4To1 from './step-4-1'
import StapPage4To2 from './step-4-2'
import StapPage4To3 from './step-4-3'
import { getChecklistNewStepDetailAPI } from '../../../../services/checklist'
import Error_500 from '../../../error/error-500'
import moment from 'moment'
import StapPage5To2 from './step-4-5(2)'

export default function StapPage4() {
  let [searchParams, setSearchParams] = useSearchParams()
  const nevigate = useNavigate()
  const org = searchParams.get('org')
  const code = searchParams.get('code')
  const clnNo = searchParams.get('id')
  const status = searchParams.get('status')
  const [dataStep1, setDataStep1] = useState()
  const [dataStep2, setDataStep2] = useState()
  const [dataStep3, setDataStep3] = useState()
  const [dataStep5, setDataStep5] = useState()
  const [approve, setApprove] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isComputer, setIsComputer] = useState(0)
  const [createDate, setCreateDate] = useState(
    moment().format('DD/MM/YYYY HH:mm')
  )
  useEffect(() => {
    getStep()
    return () => {}
  }, [])
  const getStep = async (stepId = 4) => {
    try {
      setIsLoading(true)
      const resp = await getChecklistNewStepDetailAPI({
        stepId,
        clnNo
      })
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        setIsComputer(resp.result.is_computer ? 1 : 0)
        setDataStep1(resp.result.step1)
        setDataStep2(resp.result.step2)
        setDataStep3(resp.result.step3)
        setDataStep5(resp.result.step5)
        setApprove(resp.result.step4.approve)
        setCreateDate(resp.result.insert_date)
      } else {
        setDataStep1()
        setDataStep2()
        setDataStep3([])
        setDataStep5()
      }
    } catch (error) {
      Error_500(error)
    }
  }
  const fnBack = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_4,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          status: status
        })}`
      },
      { replace: true }
    )
  }
  return (
    <>
      {isLoading && <div className="preloader"></div>}
      <Row>
        <Col
          xl={12}
          className="mt-3 mb-3"
          style={{ position: 'sticky', top: 0, zIndex: 1000 }}
        >
          <StapMainLayout current={4} />
        </Col>
        <StapPage4To1 step={dataStep1} createDate={createDate} />
        <div className="pt-5 ">
          <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
        </div>
        <StapPage5To2 step={dataStep5} createDate={createDate} />
        <div className="pt-5 ">
          <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
        </div>
        <StapPage4To2
          step={dataStep2}
          isComputer={isComputer}
          createDate={createDate}
        />
        <div className="pt-5 ">
          <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
        </div>
        <StapPage4To3 step={dataStep3} createDate={createDate} />
        <div className="pt-5">
          <p style={{ borderTop: '1px dashed rgb(135, 135, 135)' }}></p>
        </div>

        {approve && (
          <Col xl={12}>
            <p>ผู้จัดการต้นสังกัด</p>
            <div className=" mt-5 font-small-2 d-flex justify-content-center">
              <div style={{ width: 300 }}>
                {approve.url && (
                  <div className="d-flex justify-content-center">
                    <Image width={250} fluid src={approve.url} />
                  </div>
                )}

                <div className="d-flex justify-content-center">
                  ลงชื่อ
                  <div
                    style={{
                      borderBottom: '1px dashed rgb(135, 135, 135)',
                      width: 200
                    }}
                  ></div>{' '}
                  ผู้ดำเนินการ
                </div>
                <div className="d-flex justify-content-center mt-3">
                  ({approve.title_th}
                  {approve.name_th} {approve.surname_th})
                </div>
                <div className="d-flex justify-content-center fw-light mt-1">
                  {approve.position_th}
                </div>
                <div className="d-flex justify-content-center fw-light">
                  {approve.confirm_date4 &&
                    moment(approve.confirm_date4).format('DD/MM/YYYY')}
                </div>
              </div>
            </div>
          </Col>
        )}

        <div
          className="d-flex justify-content-start mt-5 bg-white"
          style={{ position: 'sticky', bottom: 0, zIndex: 1000 }}
        >
          <span className=" border-0 small pointer-event p-3 " onClick={fnBack}>
            <BsChevronDoubleLeft className="me-2 " />
            Back
          </span>
        </div>
      </Row>
    </>
  )
}
